import React, {useState} from "react";
import {useForm} from "react-hook-form";
import OrderFields from "./OrderFields";

export default function () {
  const {register, handleSubmit, reset, control, watch, setValue, getValues} = useForm();
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});

  const orderFields = <OrderFields {...{register, errors, control, watch, setValue, data, setData, getValues}} />;

  return {
    setErrors,
    orderFields,
    handleSubmit,
    watch,
    setValue,
    data,
    setData,
    reset,
  }
}